import React, { useState, useEffect, useRef } from "react";

export default function useRequestSuccessEffect(sideEffect) {
  const [requestSuccess, setRequestSuccess] = useState(false);
  const isInitialRender = useRef(true);

  useEffect(() => {
    if (isInitialRender.current || requestSuccess) {
      sideEffect();
      if (requestSuccess) {
        setRequestSuccess(false);
      }
      isInitialRender.current = false;
    }
  }, [requestSuccess, sideEffect]);

  return [requestSuccess, setRequestSuccess];
}
